import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgViewerComponent } from './svg-viewer.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  declarations: [SvgViewerComponent],
  exports: [SvgViewerComponent]
})
export class SvgViewerModule { }
